import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { OptionsColor } from "../../OptionsColor";
export var GrabLinks = /*#__PURE__*/function () {
  function GrabLinks() {
    _classCallCheck(this, GrabLinks);

    this.blink = false;
    this.consent = false;
    this.opacity = 1;
  }

  _createClass(GrabLinks, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.blink !== undefined) {
        this.blink = data.blink;
      }

      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }

      if (data.consent !== undefined) {
        this.consent = data.consent;
      }

      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);

  return GrabLinks;
}();